<template>
<e-chart ref="chart" />
</template>

<script>
export default {
  name: 'VOCsAQIPieChart',
  props: {
    unit: {
      required: true,
      type: String
    },
    data: {
      required: true,
      type: Object
    }
  },
  methods: {
    render () {
      let {unit, data, $el} = this
      let {count, maxValue} = data
      let ratio = count / maxValue
      let height = $el.offsetHeight
      let size = Math.max((height - 100) * ratio, 30)
      ratio = size / height * 100
      let chartOpt = {
        title: {
          text: data.siteName,
          subtext: `总量: ${Number(count.toFixed(2))}`,
          left: 'center'
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          },
          right: 23
        },
        tooltip: {
          trigger: 'item',
          appendToBody: true,
          formatter: ({data: {name, value, isHaveIntegral}, marker, seriesName}) => [
            `<div>${seriesName}${isHaveIntegral ? '(重积分)' : ''}</div>`,
            `<div>${marker}<span>${name}</span><span style="padding-left:20px;">${Number.isFinite(value) ? `${value.toFixed(2)}${unit}(${(value / count * 100).toFixed(2)}%)` : '--'}</span></div>`
          ].join('')
        },
        series: [{
          name: '组分均值占比',
          type: 'pie',
          radius: [`${ratio / 2}%`, `${ratio}%`],
          center: ['50%', height / 2 + 30],
          data: data.data
        }]
      }
      this.$refs.chart.setOpt(chartOpt)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/03Pollution/07VOCs-AQI/VOCsAQIPieChart.vue